import React from 'react';
import { AbsoluteFill, Img, useVideoConfig } from 'remotion';
import type { CirculoConfig, LayoutRendererProps } from '@/lib/layouts/types';
import { clampFillerSpeed } from '@/lib/layouts/clampFillerSpeed';
import { circuloCircleStyle } from '@/lib/layouts/circuloGeometry';
import { resolveFillerPlaylist } from '@/lib/layouts/fillerPlaylist';
import { resolveCirculoBackground } from '@/lib/layouts/resolveCirculoBackground';
import { FillerPlaylist } from './SatisfatorioFrame';

export const CirculoFrame: React.FC<LayoutRendererProps<CirculoConfig>> = ({
  config, media, renderClip,
}) => {
  const { width, height } = useVideoConfig();
  const bg = resolveCirculoBackground(config);
  const circle = circuloCircleStyle(width, height);
  return (
    <AbsoluteFill data-testid="circulo-frame">
      {bg === 'playlist' && (
        <AbsoluteFill>
          <FillerPlaylist
            urls={resolveFillerPlaylist(config)}
            fillerSpeed={clampFillerSpeed(config.fillerSpeed ?? 1)}
            regionW={width}
            regionH={height}
            fits={config.fillerFits}
            positions={config.fillerPositions}
            slot="background"
          />
        </AbsoluteFill>
      )}
      {bg === 'image' && config.backgroundUrl && (
        <Img src={config.backgroundUrl} style={{ width: '100%', height: '100%', objectFit: 'cover', maxWidth: 'none', maxHeight: 'none' }} />
      )}
      {bg === 'color' && (
        <AbsoluteFill style={{ backgroundColor: config.backgroundColor }} data-testid="circulo-bg-color" />
      )}
      {bg === 'blur' && (
        <div data-testid="circulo-bg-blur" style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
          <div style={{ width: '100%', height: '100%', transform: 'scale(1.25)', filter: 'blur(24px)' }}>
            {renderClip?.({ muted: true, slot: 'background' })}
          </div>
        </div>
      )}
      <div
        data-testid="circulo-clip"
        style={{
          position: 'absolute',
          left: circle.left,
          top: circle.top,
          width: circle.width,
          height: circle.height,
          borderRadius: '50%',
          overflow: 'hidden',
        }}
      >
        <div style={{ width: '100%', height: '100%' }}>{media}</div>
      </div>
    </AbsoluteFill>
  );
};
